import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WordLookup from './components/WordLookup';
import About from './components/About';
import Navigation from './components/Navigation';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<WordLookup />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;